module.exports = __webpack_public_path__ + "LatoLatin-Light.4725b48f890735506fe7.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Light.woff
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Light.woff
// module chunks = styles